const customersInfoState = {
    allCustomersInfo: undefined,
    customersInfo: undefined,
    receivingAllCustomersInfo: false,
    receivingCustomersInfo: false
};
export default customersInfoState;
